import { dataLocalStorage, getLocalStorage } from "./publicFunction";

/**
 * Converts API privileges (keyed by fct_id) into a stable map keyed by feature name.
 * Safe to call on data that is already name-keyed.
 */
export const normalizePrivilegesByName = (privileges) => {
  if (!privileges || typeof privileges !== "object") {
    return {};
  }

  const values = Object.values(privileges);
  if (
    values.length > 0 &&
    values.every((entry) => entry?.name && privileges[entry.name] === entry)
  ) {
    return privileges;
  }

  const byName = {};
  values.forEach((entry) => {
    if (entry?.name) {
      byName[entry.name] = entry;
    }
  });
  return byName;
};

export const getPrivileges = () => {
  const raw = getLocalStorage(dataLocalStorage.privileges);
  return normalizePrivilegesByName(raw);
};

export const getPrivilege = (privileges, name) => {
  return normalizePrivilegesByName(privileges)[name];
};

export const canAccess = (privileges, name, access) => {
  const privilege = getPrivilege(privileges, name);
  if (!privilege) {
    return false;
  }
  return privilege[`access_${access}`] === 1;
};
